import React, { FC, useState, useMemo, useCallback } from 'react'
import { Snackbar } from '@material-ui/core'
import flatMap from 'lodash-es/flatMap'

import T from 'components/FormattedMessage'
import TeamEditor from 'components/TeamEditor'
import { ClassicPlayersResponse, IPlayer } from 'protos'
import { useGamePlayerLayer } from 'components/PlayerLayer/hooks'
import MatchCarousel from 'components/TeamEditor/components/MatchCarousel'
import usePlayersViaURL from 'components/TeamEditor/hooks/usePlayersViaURL'
import ClassicGamePlayerList from 'components/TeamEditor/components/ClassicGamePlayerList'

type Props = {
  isLoading: boolean
  error?: any
  gameId: string
  data?: {
    groups: ClassicPlayersResponse.IGroup[]
  }
  submitting: boolean
  submitError?: any
  onSubmit: (players: IPlayer[]) => void
  dismissSubmitError: () => void
}

const SelectClassicPlayersTeamEditor: FC<Props> = ({ isLoading, error, gameId, data, submitting, submitError, dismissSubmitError, onSubmit }) => {
  const availablePlayers = useMemo(() => flatMap(data?.groups, ({ player }) => player || []), [data])

  const openPlayerLayer = useGamePlayerLayer(gameId)
  const { selectedPlayers, togglePlayer } = usePlayersViaURL({ availablePlayers })
  const [selectedMatchIndex, selectMatchIndex] = useState(0)

  const submit = useCallback(() => { onSubmit(selectedPlayers) }, [onSubmit, selectedPlayers])

  const matches = data?.groups.map(group => group.match!)
  const match = matches?.[selectedMatchIndex]
  const listedPlayers = data?.groups[selectedMatchIndex].player!

  return (
    <>
      <TeamEditor
        isLoading={isLoading}
        error={error}
        match={match}
        selectedPlayers={selectedPlayers}
        listedPlayers={listedPlayers}
        availablePlayers={availablePlayers}
        playersToCompare={selectedPlayers}
        submitText={<T id="teameditor_action_submit" />}
        header={(
          <MatchCarousel
            matches={matches || []}
            selectedMatchIndex={selectedMatchIndex}
            onMatchIndexChange={selectMatchIndex}
          />
        )}
        PlayerList={ClassicGamePlayerList}
        onPlayerClick={togglePlayer}
        onPlayerJerseyClick={openPlayerLayer}
        onSubmit={submit}
        submitting={submitting}
      />

      <Snackbar
        open={!!submitError}
        autoHideDuration={4000}
        message={<span>{submitError}</span>}
        onClose={dismissSubmitError}
      />
    </>
  )
}

export default SelectClassicPlayersTeamEditor
try {
    // @ts-ignore
    SelectClassicPlayersTeamEditor.displayName = "SelectClassicPlayersTeamEditor";
    // @ts-ignore
    SelectClassicPlayersTeamEditor.__docgenInfo = { "description": "", "displayName": "SelectClassicPlayersTeamEditor", "props": { "isLoading": { "defaultValue": null, "description": "", "name": "isLoading", "required": true, "type": { "name": "boolean" } }, "error": { "defaultValue": null, "description": "", "name": "error", "required": false, "type": { "name": "any" } }, "gameId": { "defaultValue": null, "description": "", "name": "gameId", "required": true, "type": { "name": "string" } }, "data": { "defaultValue": null, "description": "", "name": "data", "required": false, "type": { "name": "{ groups: any[]; }" } }, "submitting": { "defaultValue": null, "description": "", "name": "submitting", "required": true, "type": { "name": "boolean" } }, "submitError": { "defaultValue": null, "description": "", "name": "submitError", "required": false, "type": { "name": "any" } }, "onSubmit": { "defaultValue": null, "description": "", "name": "onSubmit", "required": true, "type": { "name": "(players: any[]) => void" } }, "dismissSubmitError": { "defaultValue": null, "description": "", "name": "dismissSubmitError", "required": true, "type": { "name": "() => void" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/routes/SelectClassicPlayers/SelectClassicPlayersTeamEditor.tsx#SelectClassicPlayersTeamEditor"] = { docgenInfo: SelectClassicPlayersTeamEditor.__docgenInfo, name: "SelectClassicPlayersTeamEditor", path: "src/routes/SelectClassicPlayers/SelectClassicPlayersTeamEditor.tsx#SelectClassicPlayersTeamEditor" };
}
catch (__react_docgen_typescript_loader_error) { }